import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

import FAQen from '../../../assets/faq/faq-en.json';
import FAQfr from '../../../assets/faq/faq-fr.json';
import { NgbAccordionDirective, NgbAccordionModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-faq',
    standalone: true,
    imports: [
        CommonModule,
        NgbAccordionModule,
        TranslocoPipe
    ],
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css'],
})
export class FaqComponent implements OnInit {

    @ViewChildren('faqAccordions') faqAccordions!: QueryList<NgbAccordionDirective>;

    faq;
    selectedDropdown: string = '';

    constructor(
        public translate: TranslocoService,
        public activeModal: NgbActiveModal
    ) { }

    ngOnInit(): void {
        this.translate.langChanges$.subscribe(lang => {
            if (lang == 'en') this.faq = FAQen;
            else if (lang == 'fr') this.faq = FAQfr;
        });
    }

    onDropdownEvent(value: any) {
        if (value == null) return;
        this.selectedDropdown = value;
    }

    beforePanelChange(panelId: string) {
        this.faqAccordions.forEach(acc => acc.collapseAll());
    }

}
